/**
 * Brands widget — A–Z index navigation + scroll-reveal for the name groups.
 */
export function initBrandsWidget() {
	document.querySelectorAll( '.brands-widget' ).forEach( initWidget );
}

function initWidget( widget ) {
	const index  = widget.querySelector( '.brands-widget__index' );
	const groups = widget.querySelectorAll( '.brands-widget__group' );
	if ( ! groups.length ) return;

	const letterButtons = index ? [ ...index.querySelectorAll( '.brands-widget__index-letter' ) ] : [];
	const gsap = window.gsap;

	// ── Jump to a letter group on click, with a short highlight pulse ──────────
	letterButtons.forEach( ( btn ) => {
		if ( btn.disabled ) return;

		btn.addEventListener( 'click', () => {
			const target = widget.querySelector( `.brands-widget__group[data-letter="${ CSS.escape( btn.dataset.letterTarget ) }"]` );
			if ( ! target ) return;

			// Clears both the fixed .site-header and the sticky A–Z index bar
			// sitting right below it (see --s-120 top offset in _brands.scss).
			const headerOffset = 140;
			const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
			window.scrollTo( { top, behavior: 'smooth' } );

			target.classList.remove( 'is-pulsing' );
			void target.offsetWidth; // restart animation if the same letter is clicked twice
			target.classList.add( 'is-pulsing' );
		} );
	} );

	// ── Highlight the letter currently in view while scrolling ─────────────────
	if ( letterButtons.length && 'IntersectionObserver' in window ) {
		const setActive = ( letter ) => {
			letterButtons.forEach( ( btn ) =>
				btn.classList.toggle( 'is-active', btn.dataset.letterTarget === letter )
			);
		};

		const observer = new IntersectionObserver(
			( entries ) => {
				const visible = entries
					.filter( ( entry ) => entry.isIntersecting )
					.sort( ( a, b ) => a.boundingClientRect.top - b.boundingClientRect.top );

				if ( visible[ 0 ] ) {
					setActive( visible[ 0 ].target.dataset.letter );
				}
			},
			{ rootMargin: '-15% 0px -70% 0px', threshold: 0 }
		);

		groups.forEach( ( group ) => observer.observe( group ) );
	}

	initGroupReveals( groups, gsap );
}

function initGroupReveals( groups, gsap ) {
	if ( ! gsap || window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) return;

	const reveal = ( group ) => {
		if ( group.dataset.brandsRevealInit ) return;
		group.dataset.brandsRevealInit = '1';

		const names = group.querySelectorAll( '.brands-widget__name' );
		if ( names.length ) {
			gsap.fromTo(
				names,
				{ y: 16, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 0.45, ease: 'power2.out', stagger: 0.02 }
			);
		}
	};

	if ( ! ( 'IntersectionObserver' in window ) ) {
		groups.forEach( reveal );
		return;
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( ! entry.isIntersecting ) return;
				observer.unobserve( entry.target );
				reveal( entry.target );
			} );
		},
		{ rootMargin: '0px 0px 12% 0px' }
	);

	groups.forEach( ( group ) => observer.observe( group ) );
}
